export default __webpack_public_path__ + "static/media/settingsSuggest.c83e6ad2.png";